<template>
    <div>
        <div class="mx-auto container pb-8">
            <div class="">

                <div v-if="include && loaded">
                    <ul class="breadcrumb list-reset flex text-grey flex-wrap pb-2" v-for="path in indicator.path">
                        <li v-for="item in path">
                            <a @click="$emit('folder', item.db, item.name)" class="cursor-pointer p-2">
                                <i class="fa fa-folder"></i> {{ item.translations.en }}
                            </a>
                        </li>
                    </ul>

                    <h1 class="text-base text-black my-4">{{ indicator.indicator.translations.en }}</h1>

                </div>

                <div class="lg:flex">
                    <div class="lg:w-1/3 lg:mr-8 lg:mb-0 mb-4">

                        <database-filter
                                class="bg-white rounded shadow-lg"
                                :database="database"
                                :codes="codes"
                        ></database-filter>
                    </div>
                    <div class="lg:w-2/3">
                        <database-series
                                class="bg-white rounded shadow-md"
                                v-if="view === 'series'"
                                :database="database"
                                :codes="codes"
                        ></database-series>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import DatabaseFilter from "./Filter.vue"
    import DatabaseSeries from "./Series";
    import * as _ from "lodash";

    export default {

        props: {
            'database': {
                type: String,
                required: true,
            },
            include: {
                type: Boolean,
                default: false,
            }
        },

        components: {
            DatabaseFilter,
            DatabaseSeries
        },

        watch: {
            database() {
                this.getStorage();
                this.loadIndicator();
            },
            'codes.selected': function () {
                this.updateState();
            },
        },

        data() {
            return {
                view: 'series',
                codes: {
                    selected: []
                },
                indicator: {},
                loaded: false,
            };
        },

        mounted() {
            this.getStorage();
            this.loadIndicator();
        },

        methods: {
            updateState() {
                sessionStorage.setItem(this.database + '.selected', JSON.stringify({
                    selected: _.uniq(this.codes.selected),
                }));
            },

            getStorage() {
                let items = JSON.parse(sessionStorage.getItem(this.database + '.selected'));

                if (items === null) {
                    items = {};
                }

                if (!items.selected || !Array.isArray(items.selected)) {
                    items.selected = [];
                }

                this.codes.selected = items.selected;
            },

            loadIndicator() {
                if (!this.include) {
                    return;
                }

                let that = this;
                http.get('/api/v1/indicators/' + this.database)
                    .then((response) => {
                        that.indicator = response.data;
                        that.loaded = true;
                    });
            }
        },

    }

</script>
